var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"layout__content-background-color background_imagem_aerovias"},[_c('transition',{attrs:{"enter-active-class":"animate__animated animate__fadeIn"}},[_c('keep-alive',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }